import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'wzf-image-box',
  templateUrl: './image-box.component.html',
  styleUrls: ['./image-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageBoxComponent {}
